import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

const LOGO = "https://customer-assets.emergentagent.com/job_pitch-connect-40/artifacts/yd54d9mb_D6EC86DD-43FE-4578-97EA-A54FBCABC788.png";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.profile_complete ? "/discover" : "/onboarding", { replace: true });
    } catch (err) {
      const msg = formatApiErrorDetail(err.response?.data?.detail) || err.message;
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10 bg-footy-bg grain">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-3 mb-8" data-testid="logo-link">
          <img src={LOGO} alt="" className="w-14 h-14 rounded-full" />
          <span className="font-display text-3xl tracking-wider">FOOTYMATCH</span>
        </Link>
        <div className="footy-card p-7">
          <h1 className="font-display text-4xl uppercase tracking-tight">Welcome back</h1>
          <p className="text-slate-400 mt-2 text-sm">Log in to find your footy match.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="footy-label">Email</label>
              <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
                     placeholder="you@example.com" className="footy-input" data-testid="login-email" />
            </div>
            <div>
              <label className="footy-label">Password</label>
              <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
                     placeholder="••••••••" className="footy-input" data-testid="login-password" />
              <div className="text-right mt-2">
                <Link to="/forgot-password" className="text-xs text-slate-400 hover:text-footy-red font-semibold uppercase tracking-widest" data-testid="link-forgot-password">
                  Forgot password?
                </Link>
              </div>
            </div>
            {error && <div className="text-sm text-footy-red bg-footy-red/10 border border-footy-red/30 rounded-lg px-3 py-2" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={loading} className="footy-btn-primary w-full" data-testid="login-submit">
              {loading ? "Logging in..." : "Log in"}
            </button>
          </form>
          <p className="text-sm text-slate-400 mt-6 text-center">
            New here? <Link to="/register" className="text-footy-red font-semibold" data-testid="link-register">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
